exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item_23 {\n  display: block;\n  padding: 5px 0 5px 5px;\n}\n.item_23:hover {\n  background-color: #d8d8da;\n}\n.icon_1 {\n  position: absolute;\n  right: 20px;\n  bottom: 10px;\n}\n.img_upload_1 {\n  max-width: 50vw;\n  max-height: 70vh;\n}\n.form_input_1 .el-textarea__inner {\n  line-height: 28px;\n  height: 15px;\n  position: relative;\n  margin-bottom: 0px;\n}\n.el-textarea {\n  vertical-align: middle;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3dfbd32a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketTaskFormItem.vue
// module id = 715
// module chunks = 75